(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-carousel_1"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('.hero-carousel').forEach(function (section) {
    var id          = section.id.replace('hero-carousel-', '');
    var track       = section.querySelector('.hero-carousel__track');
    var slides      = section.querySelectorAll('.hero-carousel__slide');
    var dots        = section.querySelectorAll('.hero-carousel__dot');
    var prevBtn     = section.querySelector('#hc-prev-' + id);
    var nextBtn     = section.querySelector('#hc-next-' + id);
    var pauseBtn    = section.querySelector('#hc-pause-' + id);
    var progressEl  = section.querySelector('.hero-carousel__progress-bar');

    if (!slides.length) return;

    var current       = 0;
    var total         = slides.length;
    var autoplay      = section.dataset.autoplay === 'true' && !reducedMotion;
    var speed         = parseInt(section.dataset.speed, 10) * 1000 || 5000;
    var paused        = false;
    var timer         = null;
    var progressStart = null;

    /* ── Hand off from LCP layer to JS track ── */
    section.classList.add('hero-carousel--ready');

    /* ── Video helpers ── */
    function getVideo(slideEl) {
      return slideEl.querySelector('[data-hc-video]');
    }

    function playVideo(slideEl) {
      var v = getVideo(slideEl);
      if (v && !reducedMotion) v.play().catch(function () {});
    }

    function pauseVideo(slideEl) {
      var v = getVideo(slideEl);
      if (v) v.pause();
    }

    /* Start video on slide 1 */
    playVideo(slides[0]);

    /* ── Go to slide n ── */
    function setSlide(n) {
      pauseVideo(slides[current]);

      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');
      if (dots[current]) {
        dots[current].classList.remove('is-active');
        dots[current].setAttribute('aria-selected', 'false');
      }

      current = ((n % total) + total) % total;

      slides[current].classList.add('is-active');
      slides[current].setAttribute('aria-hidden', 'false');
      if (dots[current]) {
        dots[current].classList.add('is-active');
        dots[current].setAttribute('aria-selected', 'true');
      }

      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      playVideo(slides[current]);
      resetProgress();
    }

    /* ── Progress bar ── */
    function resetProgress() {
      clearTimeout(timer);
      if (!progressEl) return;
      progressEl.style.transition = 'none';
      progressEl.style.width = '0%';
      if (autoplay && !paused) {
        requestAnimationFrame(function () {
          requestAnimationFrame(startProgress);
        });
      }
    }

    function startProgress() {
      if (!progressEl) return;
      progressStart = Date.now();
      progressEl.style.transition = 'width ' + speed + 'ms linear';
      progressEl.style.width = '100%';
      timer = setTimeout(function () { setSlide(current + 1); }, speed);
    }

    function freezeProgress() {
      clearTimeout(timer);
      if (!progressEl) return;
      var elapsed = Date.now() - (progressStart || Date.now());
      var pct = Math.min((elapsed / speed) * 100, 100);
      progressEl.style.transition = 'none';
      progressEl.style.width = pct + '%';
    }

    /* ── Controls ── */
    if (prevBtn) prevBtn.addEventListener('click', function () { setSlide(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { setSlide(current + 1); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        setSlide(parseInt(dot.dataset.index, 10));
      });
    });

    if (pauseBtn) {
      pauseBtn.addEventListener('click', function () {
        paused = !paused;
        var icon = pauseBtn.querySelector('.hero-carousel__pause-icon');

        if (paused) {
          freezeProgress();
          pauseVideo(slides[current]);
          pauseBtn.setAttribute('aria-label', 'Play slideshow');
          if (icon) icon.innerHTML = '<svg width="11" height="13" viewBox="0 0 11 13" fill="white"><path d="M0 0L11 6.5L0 13V0Z"/></svg>';
        } else {
          playVideo(slides[current]);
          pauseBtn.setAttribute('aria-label', 'Pause slideshow');
          if (icon) icon.innerHTML = '<span class="hero-carousel__pause-bar"></span><span class="hero-carousel__pause-bar"></span>';
          resetProgress();
        }
      });
    }

    /* ── Keyboard ── */
    section.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  setSlide(current - 1);
      if (e.key === 'ArrowRight') setSlide(current + 1);
    });

    /* ── Touch / swipe ── */
    var touchStartX = null;
    section.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });

    section.addEventListener('touchend', function (e) {
      if (touchStartX === null) return;
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) setSlide(diff > 0 ? current + 1 : current - 1);
      touchStartX = null;
    });

    /* ── Pause autoplay on hover ── */
    if (autoplay) {
      section.addEventListener('mouseenter', function () { if (!paused) freezeProgress(); });
      section.addEventListener('mouseleave', function () { if (!paused) resetProgress(); });
    }

    /* ── Start ── */
    if (autoplay) resetProgress();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-gallery"] && !Shopify.designMode) return;
  try {
    
  (function() {
    /* ═══════════════════════════════
       Lightbox (works for both grid + carousel)
       ═══════════════════════════════ */
    let lightbox = null;
    let lightboxImg = null;
    let lightboxCaption = null;
    let counter = null;
    let galleryItems = [];
    let currentIndex = 0;

    window.openGalleryLightbox = function(trigger) {
      const section = trigger.closest('.image-gallery-section');
      if (!section) return;

      galleryItems = Array.from(section.querySelectorAll('[data-gallery-src]'));
      currentIndex = galleryItems.indexOf(trigger);

      lightbox = section.parentElement.querySelector('.gallery-lightbox')
                 || section.nextElementSibling;
      if (!lightbox || !lightbox.classList.contains('gallery-lightbox')) {
        const allLightboxes = document.querySelectorAll('.gallery-lightbox');
        lightbox = allLightboxes[allLightboxes.length - 1];
      }
      if (!lightbox) return;

      lightboxImg = lightbox.querySelector('.gallery-lightbox__img');
      lightboxCaption = lightbox.querySelector('.gallery-lightbox__caption');
      counter = lightbox.querySelector('.gallery-lightbox__counter');

      showImage(currentIndex);
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    };

    window.closeGalleryLightbox = function() {
      if (!lightbox) return;
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };

    window.navigateGallery = function(direction) {
      if (!galleryItems.length) return;
      currentIndex = (currentIndex + direction + galleryItems.length) % galleryItems.length;
      showImage(currentIndex);
    };

    function showImage(index) {
      if (!lightboxImg || !galleryItems[index]) return;
      const item = galleryItems[index];
      lightboxImg.src = item.dataset.gallerySrc;
      lightboxImg.alt = item.dataset.galleryAlt || '';
      if (counter) {
        counter.textContent = (index + 1) + ' / ' + galleryItems.length;
      }
      /* Show caption in lightbox */
      if (lightboxCaption) {
        const slide = item.closest('.image-gallery__grid-item, .image-gallery__carousel-slide');
        const headingEl = slide ? slide.querySelector('.image-gallery__caption-heading') : null;
        const captionEl = slide ? slide.querySelector('.image-gallery__caption-text') : null;
        var captionHTML = '';
        if (headingEl) captionHTML += '<strong>' + headingEl.textContent + '</strong>';
        if (headingEl && captionEl) captionHTML += '<br>';
        if (captionEl) captionHTML += captionEl.textContent;
        lightboxCaption.innerHTML = captionHTML;
      }
    }

    document.addEventListener('keydown', function(e) {
      if (!lightbox || lightbox.getAttribute('aria-hidden') !== 'false') return;
      if (e.key === 'Escape') closeGalleryLightbox();
      if (e.key === 'ArrowLeft') navigateGallery(-1);
      if (e.key === 'ArrowRight') navigateGallery(1);
    });

    /* ═══════════════════════════════
       Carousel engine
       ═══════════════════════════════ */
    const carouselState = {};

    function getPerView(sectionEl) {
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const style = getComputedStyle(sectionEl);
      return parseInt(
        isMobile
          ? style.getPropertyValue('--carousel-per-view-mobile')
          : style.getPropertyValue('--carousel-per-view'),
        10
      ) || 1;
    }

    function updateCarousel(sectionId) {
      const state = carouselState[sectionId];
      if (!state) return;

      const sectionEl = document.querySelector('[data-section-id="' + sectionId + '"]');
      if (!sectionEl) return;

      const perView = getPerView(sectionEl);
      const maxIndex = Math.max(0, state.totalSlides - perView);

      if (state.currentSlide > maxIndex) state.currentSlide = maxIndex;
      if (state.currentSlide < 0) state.currentSlide = 0;

      const gap = parseFloat(getComputedStyle(sectionEl).getPropertyValue('--gallery-gap')) || 12;
      const slideWidth = (state.track.parentElement.offsetWidth - gap * (perView - 1)) / perView;
      const offset = state.currentSlide * (slideWidth + gap);
      state.track.style.transform = 'translateX(-' + offset + 'px)';

      /* Update dots */
      const dotsContainer = document.getElementById('dots-' + sectionId);
      if (dotsContainer) {
        var dots = dotsContainer.querySelectorAll('.image-gallery__carousel-dot');
        dots.forEach(function(dot, i) {
          dot.classList.toggle('is-active', i === state.currentSlide);
        });
      }
    }

    window.carouselNav = function(sectionId, direction) {
      const state = carouselState[sectionId];
      if (!state) return;

      const sectionEl = document.querySelector('[data-section-id="' + sectionId + '"]');
      const perView = getPerView(sectionEl);
      const maxIndex = Math.max(0, state.totalSlides - perView);

      state.currentSlide = state.currentSlide + direction;
      if (state.currentSlide > maxIndex) state.currentSlide = 0;
      if (state.currentSlide < 0) state.currentSlide = maxIndex;

      updateCarousel(sectionId);
      resetAutoplay(sectionId);
    };

    window.carouselGoTo = function(sectionId, index) {
      const state = carouselState[sectionId];
      if (!state) return;
      state.currentSlide = index;
      updateCarousel(sectionId);
      resetAutoplay(sectionId);
    };

    function resetAutoplay(sectionId) {
      const state = carouselState[sectionId];
      if (!state || !state.autoplayInterval) return;
      clearInterval(state.autoplayInterval);
      startAutoplay(sectionId);
    }

    function startAutoplay(sectionId) {
      const state = carouselState[sectionId];
      if (!state || !state.autoplay) return;
      state.autoplayInterval = setInterval(function() {
        carouselNav(sectionId, 1);
      }, state.autoplaySpeed);
    }

    /* Initialise all carousels on the page */
    function initCarousels() {
      document.querySelectorAll('.image-gallery-section--carousel').forEach(function(sectionEl) {
        const sectionId = sectionEl.dataset.sectionId;
        const track = sectionEl.querySelector('.image-gallery__carousel-track');
        if (!track) return;

        const slides = track.querySelectorAll('.image-gallery__carousel-slide');
        const autoplay = sectionEl.dataset.autoplay === 'true';
        const autoplaySpeed = parseInt(sectionEl.dataset.autoplaySpeed, 10) || 5000;

        carouselState[sectionId] = {
          track: track,
          totalSlides: slides.length,
          currentSlide: 0,
          autoplay: autoplay,
          autoplaySpeed: autoplaySpeed,
          autoplayInterval: null
        };

        updateCarousel(sectionId);
        if (autoplay) startAutoplay(sectionId);

        /* Pause autoplay on hover */
        sectionEl.addEventListener('mouseenter', function() {
          var state = carouselState[sectionId];
          if (state && state.autoplayInterval) {
            clearInterval(state.autoplayInterval);
            state.autoplayInterval = null;
          }
        });

        sectionEl.addEventListener('mouseleave', function() {
          var state = carouselState[sectionId];
          if (state && state.autoplay && !state.autoplayInterval) {
            startAutoplay(sectionId);
          }
        });

        /* Touch / swipe support */
        let touchStartX = 0;
        let touchDiff = 0;
        track.addEventListener('touchstart', function(e) {
          touchStartX = e.touches[0].clientX;
        }, { passive: true });
        track.addEventListener('touchmove', function(e) {
          touchDiff = e.touches[0].clientX - touchStartX;
        }, { passive: true });
        track.addEventListener('touchend', function() {
          if (Math.abs(touchDiff) > 50) {
            carouselNav(sectionId, touchDiff > 0 ? -1 : 1);
          }
          touchDiff = 0;
        });
      });
    }

    /* Handle resize */
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        Object.keys(carouselState).forEach(function(id) {
          updateCarousel(id);
        });
      }, 150);
    });

    /* Init on DOM ready */
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCarousels);
    } else {
      initCarousels();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
